export const FETCH_CSV_UPLOAD_REQUEST = "FETCH_CSV_UPLOAD_REQUEST";
export const FETCH_CSV_UPLOAD_SUCCESS = "FETCH_CSV_UPLOAD_SUCCESS";
export const FETCH_CSV_UPLOAD_FAILURE = "FETCH_CSV_UPLOAD_FAILURE";
